<div class="container">
  <div class="row m-auto">
    <div class="d-flex flex-lg-row flex-column justify-content-center">
      <div class="videowrapper row align-items-center">
        <h2 class="text-center font-weight-bold">
          <span>{{ title }}</span>
        </h2>

        <div
          class="wistia_video_foam_dummy"
          data-source-container-id=""
          style="
            border: 0px;
            display: block;
            height: 0px;
            margin: 0px;
            padding: 0px;
            position: static;
            visibility: hidden;
            width: auto;
          "></div>
        <iframe
          src="https://player.vimeo.com/video/85789977?h=cf8dac28e2"
          width="640"
          height="360"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>
